import { render, staticRenderFns } from "./Returnfreight.vue?vue&type=template&id=f05a8ca4&scoped=true"
import script from "./Returnfreight.vue?vue&type=script&lang=js"
export * from "./Returnfreight.vue?vue&type=script&lang=js"
import style0 from "./Returnfreight.vue?vue&type=style&index=0&id=f05a8ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05a8ca4",
  null
  
)

export default component.exports